export const CLIENT_TYPES = {
    Venture_Capital_Private_Equity: "Venture Capital/Private Equity",
    Hedge_Funds_Public_Markets: "Hedge funds/Public Markets",
    Research_Consulting: "Research and Consulting",
    Corporations_Companies: "Corporations and Companies",
}

export const CATEGORY_OPTIONS_LISTS = {
    CONSULTING: [
        "General Strategy",
        "Due Diligence / PIPE",
        "Letter of Proposal",
        "Internal Study",
    ],
    INVESTMENT_FUNDS: [
        "Exploratory",
        "Due Diligence",
        "Portfolio Management"    
    ],
}

export const CLIENT_TYPE_TO_CATEGORY_OPTIONS_MAP = {
    [CLIENT_TYPES.Venture_Capital_Private_Equity]: CATEGORY_OPTIONS_LISTS.INVESTMENT_FUNDS,
    [CLIENT_TYPES.Hedge_Funds_Public_Markets]: CATEGORY_OPTIONS_LISTS.INVESTMENT_FUNDS,
    [CLIENT_TYPES.Research_Consulting]: CATEGORY_OPTIONS_LISTS.CONSULTING,
}

export const PROJECT_TYPES = {
    PROJECT: "Project",
    WORKSTREAM: "Workstream",
    WORKSTREAM_AUTOMATED: "Workstream - Automated",
    SURVEY: "Survey",
}

export const PROJECT_TYPE_OPTIONS = [
    {
        label: "Project",
        value: "Project",
    },
    {
        label: "Workstream",
        value: "Workstream",
    },
    {
        label: "Workstream - Automated",
        value: "Workstream - Automated",
    },
    {
        label: "Survey",
        value: "Survey",
    },
    {
        label: "Extension",
        value: "Extension",
    },
]

export const DEFAULT_PROJECT_TYPE = PROJECT_TYPE_OPTIONS[0];